export default __webpack_public_path__ + "static/media/outdoor.b6a4ddf9.jpg";